<script setup>
import { computed, getCurrentInstance } from 'vue';
import Button from "../../common/Button.vue";

const props = defineProps({
    tableName: {
        type: String,
        required: true
    }
});

const { proxy } = getCurrentInstance();
const store = proxy.$store;
const route = proxy.$route;
const router = proxy.$router;

// --- Computed ---

const component = computed(() => {
    return store.state.components.items.find(o => o.tableName === props.tableName);
});

const user = computed(() => {
    return store.state.user.user;
});

const show = computed(() => {
    // Administrator can always see it
    if (user.value.administrator) {
        return true;
    }

    // Otherwise, check for form admin access and if the component belongs to the "Forms" group
    return (
        user.value.access?.__formAdmin &&
        component.value?.navigationGroup === 'Forms'
    );
});

// --- Methods ---

const goToComponentSettings = () => {
    // Use the component name from the current route parameters
    const tableNameParam = route.params.component;
    router.push({
        name: 'componentSettings',
        params: { component: tableNameParam }
    });
};
</script>

<template>
    <Button v-if="show" @click.native="goToComponentSettings">
        <i class="bi-gear-fill me-2"/>
        Settings
    </Button>
</template>

<style scoped>
/* Scoped styles preserved empty */
</style>